// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-wrapper {
  position: relative;
}

input {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 2.3rem;
  margin: 10px;
  line-height: 6ex;
}

.selectfile {
  width: 98%;
}

.label_edittext {
  position: absolute;
  top: -0.6rem;
  z-index: 1;
  left: 1em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}

.select-wrapper {
  position: relative;
  display: block;
}

.input::placeholder {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
}

.select_category {
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 400;
  color: #A3AEC4 !important;
}

::placeholder {
  padding: 0rem 0rem !important;
}

select {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 94%;
  height: 2.5rem;
}

.new_part-select {
  width: 20.5vw;
}

.edit_textfield {
  display: flex;
  gap: 2rem;
  width: 60%;
  background: #ffffff;
  border-radius: 6px;
  background: #ffffff;
  border-radius: 6px;
  margin: 1rem;
  padding: 0.6rem 0rem;
}

.edit_textfield-input {
  display: flex;
  gap: 2rem;
  width: 96%;
  background: #ffffff;
  border-radius: 6px;
  background: #ffffff;
  border-radius: 6px;
  margin: 1rem;
  padding: 0.6rem 0rem;
}

.button_search_part {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #ffffff;
  width: 12%;
  height: 2.5rem;
  text-align: center;
  justify-content: center;
  border: none;
  margin: 0.6rem 1rem;
}

.partlistdropdowndiv_file {
  width: 100%;
}

.select {
  font-family: Nunito;
  font-size: 14px;
  font-weight: 700;
  color: #0C3688;
  margin: 0rem -4rem;
  z-index: 4;
  position: inherit;
}

.select-input {
  font-family: Nunito;
  font-size: 16px;
  font-weight: 700;
  color: #0C3688;
  margin: 0rem -8.5rem;
  z-index: 4;
  cursor: pointer;
  position: inherit;
}

.download-button {
  color: #0C3688;
  margin-left: 10px;
  background: none;
  font-weight: 700;
}

.download-button:disabled {
  color: #6684bf;
}

@media screen and (min-width: 300px) and (max-width: 768px) {
  .new_part-select {
    width: 40vw;
  }
  .edit_textfield {
    width: 100%;
  }
  .selectfile {
    width: 70% !important;
  }
  .partlistdropdowndiv_file {
    width: 95%;
  }
  .select-input {
    font-size: 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/EditTextfieldComponent/edittext.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEE;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AACJ;;AACE;EACE,UAAA;AAEJ;;AAAE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAGJ;;AAAE;EACE,kBAAA;EACA,cAAA;AAGJ;;AADE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAIJ;;AAFE;EACE,qBAAA;EACJ,eAAA;EACA,gBAAA;EACA,yBAAA;AAKA;;AAFE;EACE,6BAAA;AAKJ;;AAHE;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AAMJ;;AAJE;EACE,aAAA;AAOJ;;AALE;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;AAQJ;;AALE;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;AAQJ;;AALE;EACE,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AAQJ;;AANE;EACE,WAAA;AASJ;;AAPE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;AAUJ;;AARE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AAWJ;;AATE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAYJ;;AAVE;EACE,cAAA;AAaJ;;AAXE;EACE;IACE,WAAA;EAcJ;EAZE;IACE,WAAA;EAcJ;EAZE;IACE,qBAAA;EAcJ;EAZE;IACE,UAAA;EAcJ;EAZE;IACE,0BAAA;EAcJ;AACF","sourcesContent":[".input-wrapper {\n    position: relative;\n  }\n  \n  input {\n    border: 1px solid gray;\n    border-radius: 6px;\n    position: relative;\n    width: 92%;\n    height: 2.3rem;\n    margin: 10px;\n    line-height: 6ex;\n  }\n  .selectfile{\n    width: 98%;\n  }\n  .label_edittext {\n    position: absolute;\n    top: -0.6rem;\n    z-index: 1;\n    left: 1em;\n    background-color: white;\n    padding: 0 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #0c3688;\n  }\n  \n  .select-wrapper {\n    position: relative;\n    display: block;\n  }\n  .input::placeholder {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #10132e;\n  }\n  .select_category{\n    font-family: \"Nunito\";\nfont-size: 16px;\nfont-weight: 400;\ncolor:#A3AEC4 !important;\n\n  }\n  ::placeholder{\n    padding: 0rem 0rem !important;\n  }\n  select {\n    border: 1px solid gray;\n    border-radius: 6px;\n    position: relative;\n    margin: 10px;\n    line-height: 6ex;\n    width: 94%;\n    height: 2.5rem;\n  }\n  .new_part-select{\n    width: 20.50vw;\n  }\n  .edit_textfield {\n    display: flex;\n    gap: 2rem;\n    width: 60%;\n    background: #ffffff;\n    border-radius: 6px;\n    background: #ffffff;\n    border-radius: 6px;\n    margin: 1rem;\n    padding: 0.6rem 0rem;\n  }\n\n  .edit_textfield-input {\n    display: flex;\n    gap: 2rem;\n    width: 96%;\n    background: #ffffff;\n    border-radius: 6px;\n    background: #ffffff;\n    border-radius: 6px;\n    margin: 1rem;\n    padding: 0.6rem 0rem;\n  }\n  \n  .button_search_part {\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    color: #ffffff;\n    width: 12%;\n    height: 2.5rem;\n    text-align: center;\n    justify-content: center;\n    border: none;\n    margin: 0.6rem 1rem;\n  }\n  .partlistdropdowndiv_file{\n    width: 100%;\n  }\n  .select{\n    font-family: Nunito;\n    font-size: 14px;\n    font-weight: 700;\n    color: #0C3688;\n    margin: 0rem -4rem;\n    z-index: 4;\n    position: inherit;\n  }\n  .select-input{\n    font-family: Nunito;\n    font-size: 16px;\n    font-weight: 700;\n    color: #0C3688;\n    margin: 0rem -8.5rem;\n    z-index: 4;\n    cursor: pointer;\n    position: inherit;\n  }\n  .download-button{\n    color: #0C3688;\n    margin-left: 10px;\n    background: none;\n    font-weight: 700;\n  }\n  .download-button:disabled{\n    color: #6684bf;\n  }\n  @media screen and (min-width:300px) and (max-width:768px) {\n    .new_part-select{\n      width: 40vw;\n    }\n    .edit_textfield{\n      width: 100%;\n    }\n    .selectfile{\n      width: 70% !important;\n    }\n    .partlistdropdowndiv_file{\n      width: 95%;\n    }\n    .select-input{\n      font-size: 12px !important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
